// extracted by mini-css-extract-plugin
module.exports = {"reviewPage":"ReviewPage_reviewPage__2lK2x","loading":"ReviewPage_loading__3FNjv","error":"ReviewPage_error__3JoC5"};